import * as auth from '../auth'

export const vehiclesSelector = createSelector(auth.selectors.userSelector, user => (user ? user.vehicles : []))

export const updateAccountPendingSelector = state => state.pending.updateAccount
